// extracted by mini-css-extract-plugin
module.exports = {"drawer-transition":"DrawerTransition_drawer-transition__9FRD5","drawer-transition_open":"DrawerTransition_drawer-transition_open__Wf2iM"};